import { URLS } from "@core/shared/utils";
import { Button } from "@design-system/components/Button";
import { BaseLink } from "@design-system/components/link";
import { trans } from "@mongez/localization";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-4">
      <div className="space-y-6 text-center">
        <h1 className="text-9xl font-bold text-gray-900 dark:text-gray-100">
          404
        </h1>
        <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-200">
          {trans("error.pageNotFound")}
        </h2>
        <p className="mx-auto max-w-md text-gray-600 dark:text-gray-300">
          {trans("error.pageNotFoundMessage")}
        </p>
        <BaseLink to={URLS.home} className="mt-4 block">
          <Button>{trans("returnToHome")}</Button>
        </BaseLink>
      </div>
    </div>
  );
}
